import authHeader from './auth.header.js';
import constants from './constants.js'
import { apiFetch as fetch } from './api.js'

const HOST_URL = constants.API_URL

export async function fetchThematicsFromCountry(countryCode) {

    const response = await fetch(`${HOST_URL}/thematics/${countryCode}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

// Une thématique est désignée par l'id du nœud ; un nom ou un code (ancien format) passe par les anciens endpoints
export const isNodeId = (value) => /^\d+$/.test(String(value ?? ""))

export async function fetchThematicsTree(country) {
    const user = JSON.parse(localStorage.getItem("user"));
    const query = country ? `?country=${encodeURIComponent(country)}` : ""
    const response = await fetch(`${HOST_URL}/thematics/tree/${user.id}${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.status)
        return { country, favorites: [], tree: [] }
    }

    return await response.json()
}

export async function fetchAllThematics() {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await fetch(`${HOST_URL}/thematics/name/${user.id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function fetchRawThematics() {
    const response = await fetch(`${HOST_URL}/thematics/raw`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function fetchCseFromThematic(name, countryCode) {
    const path = isNodeId(name)
        ? `${HOST_URL}/thematics/node/${name}/cse/${countryCode}`
        : `${HOST_URL}/thematics/cse/${encodeURIComponent(name)}/${countryCode}`
    const response = await fetch(path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    return await response.text()
}

export async function fetchCountryInfo(country) {
    const response = await fetch(`${HOST_URL}/thematics/country/infos/${country}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function toggleUserThematic(user_id, thematic_id) {
    const response = await fetch(`${HOST_URL}/thematics/user/toggle`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ user_id: user_id, thematic_id: thematic_id })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function fetchLinksThematics(thematicName, countryCode, igo) {
    let url = isNodeId(thematicName)
        ? `${HOST_URL}/thematics/node/${thematicName}/links/${countryCode}`
        : `${HOST_URL}/thematics/links/${countryCode}/${encodeURIComponent(thematicName)}`;
    if (igo) {
        url += `/${igo}`;
    }
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    if (response.status === 204) {
        return []
    }

    return await response.json()
}

export async function fetchCse(firstElement, lastElement, query) {
    const response = await fetch(`${HOST_URL}/thematics/cse/get/${firstElement}/${lastElement}${query ? "/"+query : ""}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...authHeader(),
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.text())
            return []
        }
    
        const jsonResponse = await response.json()
        return jsonResponse
}

export async function getOneCse(id) {
    const response = await fetch(`${HOST_URL}/thematics/cse/get/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse

}

export async function addCse(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 4) return
    const response = await fetch(`${HOST_URL}/thematics/cse/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function deleteCse(id) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 4) return
    const response = await fetch(`${HOST_URL}/thematics/cse/delete/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function updateCse(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 4) return
    const response = await fetch(`${HOST_URL}/thematics/cse/update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function fetchLinksThematicsWithOffsetAndLimit(country, firstElement, lastElement, query) {
    const response = await fetch(`${HOST_URL}/thematics/links/get/${country}/${firstElement}/${lastElement}${query ? "/"+query : ""}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function fetchOneLink(id) {
    const response = await fetch(`${HOST_URL}/thematics/links/get/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse

}

export async function addLink(request) {
    const response = await fetch(`${HOST_URL}/thematics/links/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function deleteLink(id) {
    const response = await fetch(`${HOST_URL}/thematics/links/delete/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function updateLink(request) {
    const response = await fetch(`${HOST_URL}/thematics/links/update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function getSearchInCseThematic(thematicName, countryCode) {
    const path = isNodeId(thematicName)
        ? `${HOST_URL}/thematics/node/${thematicName}/search-in-cse/${countryCode}`
        : `${HOST_URL}/thematics/cse/get/search/${encodeURIComponent(thematicName)}/${countryCode}`
    const response = await fetch(path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}


const thematics = {
    fetchThematicsFromCountry
}
export default thematics;
